export enum RestrictionsTypes {
    WARNING = "Warning",
    ERROR = "Error",
}